import * as React from 'react';
import { MessageSquareIcon } from 'lucide-react';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import { Timeline } from 'components/ui/timeline';
import { Card, CardContent } from 'components/ui/card';
import { Formatter } from 'utils';
import { TimelineContainer, TimelineSkeletonCard, UserCircleICon } from './ui-kit';

type TimeLineEvent = {
  id: string;
  createdAt: string;
  description: string;
  userName: string;
}

type Props = React.ComponentProps<'div'>

export const JustificationsTimeline = (props: Props) => {
  const { invoice } = useInvoiceStore();

  const timelineEvents = React.useMemo((): TimeLineEvent[] => {
    if (!invoice?.justifications) {
      return [];
    }

    return invoice.justifications.map(justification => ({
      id: justification.id.toString(),
      createdAt: justification.created_at,
      description: justification.description,
      userName: justification?.user?.name || 'Sistema',
    })).sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  }, [invoice]);

  if (!invoice) {
    return (
      <TimelineContainer
        {...props}
        timelineIcon={<MessageSquareIcon />}
        timelineTitle={'Justificativas'}
      >
        <Timeline className={'py-6'}>
          {Array.from({ length: 3 }).map((_, index) => (
            <TimelineSkeletonCard key={index} />
          ))}
        </Timeline>
      </TimelineContainer>
    );
  }

  return (
    <TimelineContainer
      {...props}
      timelineIcon={<MessageSquareIcon />}
      timelineTitle={'Justificativas'}
    >
      <Timeline className={'py-6 flex-1'}>
        {timelineEvents?.map((event) => (
          <Card key={event.id} className={'shadow-none w-full max-w-[460px]'}>
            <CardContent className={'pt-6'}>
              <div className={'flex items-center gap-2 mb-4'}>
                <UserCircleICon />
                <span className={'font-GilroySemibold text-[14px] text-black'}>{event.userName}</span>
              </div>
              <p className={'text-gray-600 text-xs'}>{event.description}</p>
              <p className={'text-gray-400 text-xs mt-4'}>
                {Formatter.date(event.createdAt, { format: 'dd/MM/yyyy HH:mm' })}
              </p>
            </CardContent>
          </Card>
        ))}
      </Timeline>
    </TimelineContainer>
  );
};
